import type {
  ApiRequestBody,
  ApiResponseBody,
  ApiSearchQuery,
} from "@/lib/api/api-type-helper";

export type GetHealthInsuranceAssociationsParams = ApiSearchQuery<
  "/v2/health-insurance-associations",
  "get"
>;

export type OrderBy = Exclude<
  GetHealthInsuranceAssociationsParams["orderBy"],
  undefined
>;

export const ORDER_BY = {
  id: "id",
  associationTypeLabel: "associationType",
  associationName: "associationName",
} satisfies Record<string, OrderBy>;

export type HealthInsuranceAssociationType =
  GetHealthInsuranceAssociationTypesRes["items"][number]["associationType"];

export type GetHealthInsuranceAssociationsRes = ApiResponseBody<
  "/v2/health-insurance-associations",
  "get"
>;

export type GetHealthInsuranceAssociationTypesRes = ApiResponseBody<
  "/v2/health-insurance-association-types",
  "get"
>;

export type CreateHealthInsuranceAssociationParams = ApiRequestBody<
  "/v2/health-insurance-associations",
  "post"
>;

export type UpdateHealthInsuranceAssociationParams = ApiRequestBody<
  "/v2/health-insurance-associations/{id}",
  "patch"
>;
